import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import appInfo from "@common/appInfo";
import { connect } from "react-redux";
import Component, { type MapProps } from "./component";

type Props = RootContainerProps & {};

const makeMapStateToProps = () => {
  const orderForSelector = getSettingValueSelector(TargetSelector.Entity, "orderFor");
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: Props): MapProps => {
    return {
      ...props,
      isVisible: orderForSelector(state, props) && !!appInfo.user?.id,
      userId: appInfo.user?.id,
      apiInfo: apiInfoSelector(state, props)
    };
  };
};

export default connect(makeMapStateToProps)(Component);
